import { useGame } from "./GameContext";

const HINTS = [
  "기억의 조각 #INV1-A01",
  "기억의 조각 #INV1-A02",
  "기억의 조각 #INV1-A03",
  "기억의 조각 #INV1-A04",
  "기억의 조각 #INV1-A05",
  "기억의 조각 #INV1-A06",
  "기억의 조각 #INV1-B01",
  "기억의 조각 #INV1-B02",
  "기억의 조각 #INV1-B03",
  "기억의 조각 #INV1-B04",
  "기억의 조각 #INV1-B05",
  "기억의 조각 #INV1-B06",
  "기억의 조각 #INV2-1",
  "기억의 조각 #INV2-2",
  "기억의 조각 #INV2-3",
  "기억의 조각 #INV2-4",
  "기억의 조각 #INV2-5",
  "기억의 조각 #INV2-6",
  "기억의 조각 #INV3-1",
  "기억의 조각 #INV3-2",
  "기억의 조각 #INV3-3",
  "기억의 조각 #INV3-4",
  "기억의 조각 #INV3-5",
  "기억의 조각 #INV3-6",
  "기억의 조각 #INV3-7",
  "기억의 조각 #INV4-1",
  "기억의 조각 #INV4-2",
  "기억의 조각 #INV4-3",
  "기억의 조각 #INV4-4",
  "기억의 조각 #INV4-5",
  "기억의 조각 #INV4-6",
  "기억의 조각 #INV4-7",
  "기억의 조각 #INV4-8",
];

export default function HintList() {
  const { clearedStages, openHintDetail } = useGame();

  return (
    <div className="hint_list storage_list_box_con con_box_storage con_box_storage01">
      <div className="storageListGap box_con con_pd6">
        <p className="storage_tit mb8">단서 보관 상자</p>
        <p className="storage_txt mb40">단서 조각을 모두 수집하세요.</p>

        <div className="storage_pBox">
          {HINTS.map((txt, idx) => {
            const stageKey = `q${idx + 1}`;
            const isUnlocked = clearedStages.has(stageKey);

            return (
              <a
                key={idx}
                className={`mb16 storage_ck storage_${idx + 1} ${
                  isUnlocked ? "sel" : ""
                }`}
                onClick={() => {
                  if (!isUnlocked) return;
                  openHintDetail(idx);
                }}
              >
                {txt}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
